var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-recipe-detail"},_vm._l((_vm.items),function(recipe,p){return _c('detail-card',{key:`${recipe.id}${p}`,attrs:{"medical-record-id":_vm.id,"recipe":recipe,"can-sign":_vm.canSign,"patient":_vm.patient,"professional-name":_vm.professionalName}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }